import { render, staticRenderFns } from "./PieChart.vue?vue&type=template&id=d63f2110&"
import script from "./PieChart.vue?vue&type=script&lang=js&"
export * from "./PieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/noblecare-backend.mindful-birthing.com.tw/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d63f2110')) {
      api.createRecord('d63f2110', component.options)
    } else {
      api.reload('d63f2110', component.options)
    }
    module.hot.accept("./PieChart.vue?vue&type=template&id=d63f2110&", function () {
      api.rerender('d63f2110', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/reserve_system_dashboard/components/PieChart.vue"
export default component.exports